<div class="kt-portlet">
	<kt-portlet-header [title]="'Connection Logs'" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>
	<div class="kt-portlet__body">
		<table class="table" *ngIf="connLogs">
			<thead>
			  <tr>
				<th>Status</th>
				<th>Time</th>
				<th>Reason</th>
			  </tr>
			</thead>
			<tbody>
			  <tr *ngFor="let log of connLogs">
				<td *ngIf="log.connectivity === 'offline'"> <i class="ml-1 fa fa-genderless fa-2x kt-font-danger"></i></td>
				<td *ngIf="log.connectivity === 'online'"><i class="ml-1 fa fa-genderless fa-2x kt-font-success"></i></td>
				<td class="align-middle">{{log.date_utc | date:'MM/dd/yy hh:mm:ss a'}}</td>
				<td class="align-middle">{{(log.reason)?log.reason:'NA'}}</td>
			  </tr>
			</tbody>
		  </table>
	</div>
</div>
<!-- <div class="card">
	<ul>
		<li *ngFor="let log of connLogs">{{log.m_id}}</li>
	</ul>
	<pre  style="color: blue;">{{JSON.stringify(connLogs)}}</pre>
</div> -->
